// Custom JS

document.addEventListener("DOMContentLoaded", function() {
    var productInfoBlocks = document.querySelector('.product-info__block-list.choose-size');
    var labelClickables = productInfoBlocks?.querySelectorAll('.variant-picker__option--size .variant-picker__option-values label');
    var clickables = [];

    if(typeof productInfoBlocks != 'undefined') {
        labelClickables?.forEach(function(el, index) {
            clickables[index] = el;
            clickables[index].addEventListener("click", function(e) {
                console.log("Test click label");
                if(productInfoBlocks.classList.contains('choose-size')) {
                    productInfoBlocks.classList.remove('choose-size')
                }
            });
        });
        
        document.addEventListener("variant:change", function(e) {
            if(e.detail.previousVariant.option1 !== e.detail.variant.option1) {
                labelClickables = productInfoBlocks.querySelectorAll('.variant-picker__option--size .variant-picker__option-values label');
                clickables = [];

                labelClickables.forEach(function(el, index) {
                    clickables[index] = el;
                    clickables[index].addEventListener("click", function(e) {
                        console.log("Test click label");
                        if(productInfoBlocks.classList.contains('choose-size')) {
                            productInfoBlocks.classList.remove('choose-size')
                        }
                    });
                });
                
                if(!productInfoBlocks.classList.contains('choose-size')) {
                    productInfoBlocks.classList.add('choose-size');
                }
            } else if(productInfoBlocks.classList.contains('choose-size')) {
                productInfoBlocks.classList.remove('choose-size');
            }

            
            // var optionLabel = e.detail.variant.option1;

            // console.log("Something change", e);
            // console.log(activeInput);
            // if(typeof activeInput != 'undefined') {
            //     activeInput.removeAttribute('checked');
            // }   
            // variantPickerInputs.forEach(function(el, index) {
            //     if(el.dataset.label == optionLabel) {
            //         setTimeout(function() {
            //             console.log(el.dataset.label + " - " + optionLabel);
            //             variantPickerInputs[index].setAttribute('checked', 'checked');
            //             activeInput = el;
            //             console.log(el);
            //         }, 2000);
            //     }
            // });
        });
    }
});